import React from "react";

/**
 * Checks if a React node is a Material-UI ListSubheader element.
 * @param child 
 * @returns True if the node is a ListSubheader element, false otherwise.
 */
export const isMuiListSubheaderElement = (child: React.ReactNode): child is React.ReactElement => {
    if (!React.isValidElement(child)) {
        return false;
    }

    const props = child.props as { children?: React.ReactNode; value?: string | number };
    const type = child.type as { displayName?: string; muiName?: string; name?: string };
    const label = "ListSubheader";

    return (
        props.value === undefined && (type.muiName === label || type.displayName?.includes(label) || type.name === label)
    );
};